import { fetchViewersForPatient } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type { FetchViewersForPatientResponseT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export async function fetchCarePatientViewers(
  userId: string,
  signal?: AbortSignal
): Promise<FetchViewersForPatientResponseT> {
  const config = await createLotusRequestConfig({ signal });
  const response = await fetchViewersForPatient(userId, config);
  return lotusHealthZod.fetchViewersForPatientResponse.parse(
    response.data
  ) as FetchViewersForPatientResponseT;
}
